import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Country, CustomValidation, FilterType, InputType, MultiLingualTextBoxOptions, PhoneOptions, TextBoxOptions, ToggleSlideOptions, EnglishArabicDTO } from 'bnsights-control-library';
import { ControlLayout, DropdownOptions, FilterItem, PagingOptions } from 'bnsights-control-library';
import { AddUserModel } from '../shared/models/UserModels/AddUserModel';
import { DropdownsResponseModel } from '../shared/models/UserModels/DropdownsResponseModel';
import { EditUserModel } from '../shared/models/UserModels/EditUserModel';
import { userService } from '../shared/Services/userService.service';
import { HttpParams } from '@angular/common/http';
import { saveAs } from 'file-saver';
import { PageInfoService } from '../../_metronic/core/services/page-info.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService, UtilityService, BBSFTranslateService, EnvironmentService } from 'bnsights-utilities-library';
import { DataSource } from '@angular/cdk/collections';

@Component({
  selector: 'lib-users',
  templateUrl: './users.component.html'
})
export class UsersComponent implements OnInit {

  ApiUrl = "/api/admin/Users/"
  SubheaderTitle = this.utilityService.getResourceValue('Users');
  ShowToolbar = true;
  ShowbreadCrumb = false;
  ShowPageContent = false;
  permissionSetsOptions: DropdownOptions;
  accountStatusOptions: DropdownOptions;
  lockedStatusOptions: DropdownOptions;
  departmentsOptions: DropdownOptions;
  searchTextBox: TextBoxOptions;
  SelectedUserList = [];
  permissionSetList = [];
  accountStatusList = [];
  lockedStatusList = [];
  departmentsList = [];
  activityStatusList = [];
  filterForm = new FormGroup({});
  UsersForm = new FormGroup({});
  showFilter: boolean = false;
  UserPagingResult: any[] = [];
  UserPaging: PagingOptions;
  permissionSetsFilter: FilterItem;
  lockedStatusFilter: FilterItem;
  accountStatusFilter: FilterItem;
  departmentsFilter: FilterItem;
  TextInputFilter: FilterItem;
  IsFilterLoaded: boolean = false;
  IsFilterDataLoaded: boolean = false;
  @ViewChild('UserPagingViewElement', { static: false }) input: ElementRef;

  //Add Model Controls
  AddUserForm = new FormGroup({});
  MultiLingualName: MultiLingualTextBoxOptions
  // NameInEnglish: TextBoxOptions;
  // NameInArabic: TextBoxOptions;
  MobileNumber: PhoneOptions;
  Username: TextBoxOptions;
  SamAccount: TextBoxOptions;
  UserDepartment: DropdownOptions;
  SendActivationEmail: ToggleSlideOptions;
  UserPermissions: DropdownOptions;
  @ViewChild('CloseUserModal', { static: false }) CloseUserModal: ElementRef;

  //Edit Model Controls
  EditUserForm = new FormGroup({});
  EditMultiLingualName: MultiLingualTextBoxOptions
  EditMobileNumber: PhoneOptions;
  EditUsername: TextBoxOptions;
  EditEmail: TextBoxOptions;
  EditSamAccount: TextBoxOptions;
  EditUserDepartment: DropdownOptions;
  EditUserPermissions: DropdownOptions;
  UserId: number;


  //Deactivate/Activate User Model Controls
  ShowActivateModelData: boolean = false
  ActivatUserList: any[] = []
  DeActivatUserList: any[] = []
  Name: string
  SaveLabel: string
  Users: string
  CancelLabel: string
  DeleteLabel: string
  Email: string
  @ViewChild('CloseEditUserModal', { static: false }) CloseEditUserModal: ElementRef;
  @ViewChild('EditUserModal', { static: false }) EditUserModal: ElementRef;
  //Reset Password User Model Controls
  ResetPasswordUserList: any[] = []
  OpenResetPasswordUserModal: boolean = false
  @ViewChild('CloseResetPasswordUserModal', { static: false }) CloseResetPasswordUserModal: ElementRef;
  //set Password User Model Controls
  SetUserPasswordForm = new FormGroup({});
  Password: TextBoxOptions;
  PasswordConfirmation: TextBoxOptions;
  OpensetPasswordUserModal: boolean = false
  customValidation: CustomValidation = new CustomValidation();
  setPasswordUserList: any[] = []
  @ViewChild('ClosesetPasswordUserModal', { static: false }) ClosesetPasswordUserModal: ElementRef;

  //delete User Model Controls
  UserList: any[] = []
  OpenSendActivationEmailModal: boolean = false
  @ViewChild('CloseActivationEmailModal', { static: false }) CloseActivationEmailModal: ElementRef;



  //Confirmation  Model Controls
  IsOpenConfirmationModal: boolean;
  ConfirmationModalType: number = 0;
  ConfirmationMessage: string = "";
  @ViewChild('CloseConfirmationModal', { static: false }) CloseConfirmationModal: ElementRef;

  @ViewChild('permissionSetDDL', { static: false }) permissionSetDDL: ElementRef;
  @ViewChild('accountStatusDDL', { static: false }) accountStatusDDL: ElementRef;
  @ViewChild('lockedStatusDDL', { static: false }) lockedStatusDDL: ElementRef;
  @ViewChild('departmentsDDL', { static: false }) departmentsDDL: ElementRef;


  //Users selection
  activatedUsersSelected: number = 0;
  deActivatedUsersSelected: number = 0;
  showActivateBtn: boolean = false;
  showDeactivateBtn: boolean = false;
  showSetPassBtn: boolean = false;
  showResetPassBtn: boolean = false;
  showSendEmailBtn: boolean = false;
  showGeneralBtns: boolean = true;
  allSelected: boolean = false;
  language: string = "";
  ProductionMode: boolean = false
  constructor(private authService: AuthService, public utilityService: UtilityService, private bbsfTranslateService: BBSFTranslateService, private environmentService: EnvironmentService, private pageInfoService: PageInfoService,
    private userService: userService, private modalService: NgbModal) {
  }
  async ngOnInit() {
    this.ShowPageContent = true;
    PageInfoService.PageTitle = this.utilityService.getResourceValue("Users")
    PageInfoService.PageBreadcrumbs = [
      { title: this.utilityService.getResourceValue("Home"), path: '/Admin/Home', isSeparator: false, isActive: false },
      { title: '', path: '', isSeparator: true, isActive: false }

    ];

    this.pageInfoService.calculateTitle();
    this.pageInfoService.calculateBreadcrumbs();
    this.bbsfTranslateService.onLangChange.subscribe((event) => {
      this.ShowPageContent = false;
      this.language = event.lang;
      this.ngOnInit();
    })
    this.language = await this.utilityService.getCurrentLanguage();
    this.ProductionMode = this.environmentService.getProductionMode()
    this.initializePage();

  }




  ReinitializeUserPaging() {
    let element = this.input as any;
    element.ReinitializePaging();
    this.resetUsersCount();
    this.disableButtons();
    this.allSelected = false;

  }

  UpdateUserPaging() {
    let element = this.input as any;
    element.UpdatePaging();
    this.resetUsersCount();
    this.disableButtons();
    this.allSelected = false;

  }

  setUsersListResult(result) {
    this.UserPagingResult = result
    this.ShowPageContent = true;
    this.resetUsersCount();
    this.disableButtons();
    this.allSelected = false;
    this.utilityService.stopBlockUI();

  }

  selectAllUserList(event, Users: any[]) {
    if (this.UserPagingResult == null) {
      return;
    }
    this.UserPagingResult.forEach(u => u.selected = event.checked);

    if (event.checked) {
      for (let index = 0; index < Users.length; index++) {
        const user = Users[index];
        this.SelectedUserList.push(user);
        if (user.isActive) {
          this.activatedUsersSelected += 1;
        }
        else {
          this.deActivatedUsersSelected += 1;
        }
      }
      this.activatedUsersSelected = Users.filter((item) => { return item.isActive; }).map((item) => item.key).length;
      this.deActivatedUsersSelected = Users.filter((item) => { return !item.isActive; }).map((item) => item.key).length;
    }
    else {
      this.SelectedUserList = [];
      this.activatedUsersSelected = 0;
      this.deActivatedUsersSelected = 0;
    }
    this.enableButtons();
  }
  updateUserList(event, User) {
    this.UserPagingResult.find(u => u.id === User.id).selected = event.checked;
    this.allSelected = this.UserPagingResult != null && this.UserPagingResult.every(u => u.selected);
    if (event.checked) {
      this.SelectedUserList.push(User);
      if (User.isActive)
        this.activatedUsersSelected += 1;
      else
        this.deActivatedUsersSelected += 1;
    }
    else {
      this.SelectedUserList.forEach((value, index) => {
        if (value.id == User.id) this.SelectedUserList.splice(index, 1);
      });
      if (User.isActive)
        this.activatedUsersSelected -= 1;
      else
        this.deActivatedUsersSelected -= 1;
    }
    this.enableButtons();
  }
  enableButtons() {
    //Reset all btns
    this.disableButtons();

    if (this.activatedUsersSelected == 0 && this.deActivatedUsersSelected == 0) {
      this.showGeneralBtns = true;

    }
    else {
      this.showGeneralBtns = false;

      //if only activated users
      if (this.activatedUsersSelected > 0 && this.deActivatedUsersSelected == 0) {
        this.showDeactivateBtn = true;
        this.showResetPassBtn = true;
      }
      else if (this.deActivatedUsersSelected > 0 && this.activatedUsersSelected == 0)     //if only deActivated users
      {
        this.showActivateBtn = true;
        this.showSendEmailBtn = true;
      }
      else if (this.activatedUsersSelected > 0 && this.deActivatedUsersSelected > 0) //if activated and deactivated users selected
      {
        this.showResetPassBtn = true;
        this.showSetPassBtn = true;
      }
    }
  }
  disableButtons() {
    //Reset all btns
    this.showActivateBtn = false;
    this.showDeactivateBtn = false;
    this.showSendEmailBtn = false;
    this.showResetPassBtn = false;
    this.showSetPassBtn = false;
    this.showGeneralBtns = true;
  }
  resetUsersCount() {
    this.SelectedUserList = [];
    this.activatedUsersSelected = 0;
    this.deActivatedUsersSelected = 0;
    this.UserPagingResult.forEach(u => u.selected = false);
  }

  loadFilters() {
    if (this.showFilter === false) {
      this.showFilter = true;
    } else {
      this.showFilter = false;
    }

  }

  loadLists() {
    if (!this.IsFilterDataLoaded) {
      this.userService.Loaddropdowns().subscribe((result) => {
        let DropdownsResponseModel = result as DropdownsResponseModel;
        this.permissionSetList = DropdownsResponseModel.permessionsets;
        this.accountStatusList = DropdownsResponseModel.accountStatus;
        this.lockedStatusList = DropdownsResponseModel.lockedStatus;
        this.departmentsList = DropdownsResponseModel.departments;
        this.activityStatusList = DropdownsResponseModel.accountStatus;

        let permissionSetElement = this.permissionSetDDL as any;
        let accountStatusElement = this.accountStatusDDL as any;
        let lockedStatusElement = this.lockedStatusDDL as any;
        let departmentsElement = this.departmentsDDL as any;


        permissionSetElement.UpdateDataSource(this.permissionSetList);

        accountStatusElement.UpdateDataSource(this.accountStatusList);

        lockedStatusElement.UpdateDataSource(this.lockedStatusList);

        departmentsElement.UpdateDataSource(this.departmentsList);


        this.IsFilterDataLoaded = true;
      });
    }
  }
  initializePage() {

    // Permission Sets Init   
    this.permissionSetsOptions = new DropdownOptions();
    this.permissionSetsOptions.Name = "permissionsets"
    this.permissionSetsOptions.LabelKey = "PermissionSets"
    this.permissionSetsOptions.SingleSelection = true;
    this.permissionSetsOptions.AllowSearchFilter = true;
    this.permissionSetsOptions.Placeholder = "";

    // Account Status Init
    this.accountStatusOptions = new DropdownOptions();
    this.accountStatusOptions.Name = "accountstatus"
    this.accountStatusOptions.LabelKey = "AccountStatus"
    this.accountStatusOptions.SingleSelection = true;

    // Locked Status Init
    this.lockedStatusOptions = new DropdownOptions();
    this.lockedStatusOptions.Name = "lockedstatus";
    this.lockedStatusOptions.LabelKey = "LockedStatus";
    this.lockedStatusOptions.SingleSelection = true;

    // departments inti
    this.departmentsOptions = new DropdownOptions();
    this.departmentsOptions.Name = "departments"
    this.departmentsOptions.LabelKey = "Departments"
    this.departmentsOptions.SingleSelection = false;
    this.departmentsOptions.AllowSearchFilter = true;

    // TextBox inti
    this.searchTextBox = new TextBoxOptions();
    this.searchTextBox.Name = "searchTextBox"
    this.searchTextBox.HideLabel = true
    this.searchTextBox.Type = InputType.Text
    this.searchTextBox.Placeholder = this.utilityService.getResourceValue("SearchByNameOrEmail")


    this.permissionSetsFilter = new FilterItem();
    this.permissionSetsFilter.FormControlName = "permissionsets"
    this.permissionSetsFilter.ActionParameterName = "permissionIds"
    this.permissionSetsFilter.IsFormControl = true
    this.permissionSetsFilter.FilterType = FilterType.DropdownList

    this.accountStatusFilter = new FilterItem();
    this.accountStatusFilter.FormControlName = "accountstatus"
    this.accountStatusFilter.ActionParameterName = "accountStatusIDs"
    this.accountStatusFilter.IsFormControl = true
    this.accountStatusFilter.FilterType = FilterType.DropdownList

    this.lockedStatusFilter = new FilterItem();
    this.lockedStatusFilter.FormControlName = "lockedstatus"
    this.lockedStatusFilter.ActionParameterName = "lockedStatusIds"
    this.lockedStatusFilter.IsFormControl = true
    this.lockedStatusFilter.FilterType = FilterType.DropdownList



    this.departmentsFilter = new FilterItem();
    this.departmentsFilter.FormControlName = "departments"
    this.departmentsFilter.ActionParameterName = "departmentIds"
    this.departmentsFilter.IsFormControl = true
    this.departmentsFilter.FilterType = FilterType.DropdownList

    this.TextInputFilter = new FilterItem();
    this.TextInputFilter.FormControlName = "searchTextBox"
    this.TextInputFilter.ActionParameterName = "nameFilter"
    this.TextInputFilter.IsFormControl = true
    this.TextInputFilter.FilterType = FilterType.TextBox


    this.UserPaging = new PagingOptions();
    this.UserPaging.ActionPostURL = this.environmentService.getApiUrl() + this.ApiUrl + 'GetUsersByFilter';
    this.UserPaging.OnKeyPressFiltersControlNames = ["searchTextBox"]
    this.UserPaging.DropdownFiltersControlNames = ["permissionsets", "accountstatus", "lockedstatus", "departments"];
    this.UserPaging.Filters = [this.permissionSetsFilter, this.lockedStatusFilter, this.accountStatusFilter, this.departmentsFilter, this.TextInputFilter]
    this.UserPaging.ValidationToken = this.authService.authorizationHeaderValue()
    this.IsFilterLoaded = true;
  }

  resetFilters() {
    this.UsersForm.controls["permissionsets"].setValue([]);
    this.UsersForm.controls["accountstatus"].setValue([]);
    this.UsersForm.controls["lockedstatus"].setValue([]);
    this.UsersForm.controls["departments"].setValue([]);
    this.UsersForm.controls["searchTextBox"].setValue(null);
    let element = this.input as any;
    element.ReinitializePaging();



  }

  showAddUserModal(addUserModal) {
    this.utilityService.startBlockUI();
    this.userService.Loaddropdowns().subscribe((result) => {

      let DropdownsResponseModel = result as DropdownsResponseModel;
      this.permissionSetList = DropdownsResponseModel.permessionsets;
      this.departmentsList = DropdownsResponseModel.departments;

      this.AddUserForm = new FormGroup({});

      this.MultiLingualName = new MultiLingualTextBoxOptions();
      this.MultiLingualName.Name = "Name";
      this.MultiLingualName.ArabicLabelKey = "NameInArabic";
      this.MultiLingualName.EnglishLabelKey = "NameInEnglish";
      this.MultiLingualName.IsRequired = true;
      this.MultiLingualName.Value = null;


      this.MobileNumber = new PhoneOptions();
      this.MobileNumber.Value = null;
      this.MobileNumber.Name = "MobileNumber"
      this.MobileNumber.LabelKey = "MobileNumber"
      this.MobileNumber.ExtraClasses = "form-control bnsights-control"
      this.MobileNumber.SelectedCountryISO = Country.UnitedArabEmirates
      this.MobileNumber.PhoneValidation = true
      this.MobileNumber.AllowSearch = true

      this.Username = new TextBoxOptions();
      this.Username.Value = null;
      this.Username.Name = "Username";
      this.Username.LabelKey = "Username";
      this.Username.Type = InputType.Email;
      this.Username.IsRequired = true;

      this.SamAccount = new TextBoxOptions();
      this.SamAccount.Value = null;
      this.SamAccount.Name = "SamAccount";
      this.SamAccount.LabelKey = "SamAccount";
      this.SamAccount.Type = InputType.Email;

      this.UserDepartment = new DropdownOptions();
      this.UserDepartment.Name = "DepartmentID"
      this.UserDepartment.LabelKey = "Department"
      this.UserDepartment.SelectedItems = null;
      this.UserDepartment.DataSource = this.departmentsList
      this.UserDepartment.SingleSelection = false;
      this.UserDepartment.AllowSearchFilter = true;

      this.SendActivationEmail = new ToggleSlideOptions();
      this.SendActivationEmail.Name = "SendActivationMail"
      this.SendActivationEmail.LabelKey = "SendActivationEmail"
      this.SendActivationEmail.Value = false
      this.SendActivationEmail.ViewType = ControlLayout.Horizontal


      this.UserPermissions = new DropdownOptions();
      this.UserPermissions.Name = "PermissionSets"
      this.UserPermissions.LabelKey = "PermissionSets"
      this.UserPermissions.SelectedItems = null;
      this.UserPermissions.DataSource = this.permissionSetList
      this.UserPermissions.SingleSelection = false;
      this.UserPermissions.AllowSearchFilter = true;
      this.UserPermissions.IsRequired = true;

      this.modalService.open(addUserModal);
      this.utilityService.stopBlockUI();
    });

  }
  addUser() {
    if (this.AddUserForm.invalid) {
      return;
    }
    else {
      let ResultModel = this.AddUserForm.value;
      let UserModel = new AddUserModel();
      UserModel.Username = ResultModel.Username;
      UserModel.NameAR = ResultModel.Name.ArabicValue;
      UserModel.NameEN = ResultModel.Name.EnglishValue;
      UserModel.SamAccount = ResultModel.SamAccount;
      UserModel.OrganizationID = 1;
      if (ResultModel.DepartmentID != undefined)
        UserModel.DepartmentID = Number(ResultModel.DepartmentID);
      let PermissionSets = ResultModel.PermissionSets as string[]
      UserModel.PermissionSets = PermissionSets.map((i) => Number(i));
      UserModel.SendActivationMail = ResultModel.SendActivationMail;
      let internationalNumber: string = null;
      if (ResultModel.MobileNumber != null) {
        internationalNumber = ResultModel.MobileNumber.internationalNumber as string;
        internationalNumber = internationalNumber.replace(/\s/g, "");
      }
      UserModel.PhoneInputMobile = internationalNumber;
      this.userService.AddUser(UserModel).subscribe((result) => {
        this.modalService.dismissAll();
        let element = this.input as any;
        element.ReinitializePaging();
      }, (error) => {

      })
    }
  }

  showEditUserModal(User: any, EditUserModal) {
    this.utilityService.startBlockUI();
    this.userService.Loaddropdowns().subscribe((result) => {
      let DropdownsResponseModel = result as DropdownsResponseModel;
      this.permissionSetList = DropdownsResponseModel.permessionsets;
      this.departmentsList = DropdownsResponseModel.departments;

      this.EditUserForm = new FormGroup({});

      this.UserId = User.id

      let Name = new EnglishArabicDTO();
      Name.Arabic = User.name.arabic;
      Name.English = User.name.english;

      this.EditMultiLingualName = new MultiLingualTextBoxOptions();
      this.EditMultiLingualName.Name = "Name";
      this.EditMultiLingualName.ArabicLabelKey = "NameInArabic";
      this.EditMultiLingualName.EnglishLabelKey = "NameInEnglish";
      this.EditMultiLingualName.IsRequired = true;
      this.EditMultiLingualName.Value = Name;

      this.EditMobileNumber = new PhoneOptions();
      this.EditMobileNumber.Value = User.mobile as string;
      this.EditMobileNumber.Name = "MobileNumber"
      this.EditMobileNumber.LabelKey = "MobileNumber"
      this.EditMobileNumber.ExtraClasses = "form-control bnsights-control"
      this.EditMobileNumber.SelectedCountryISO = Country.UnitedArabEmirates
      this.EditMobileNumber.PhoneValidation = true
      this.EditMobileNumber.AllowSearch = true


      this.EditUsername = new TextBoxOptions();
      this.EditUsername.Value = User.username;
      this.EditUsername.Name = "Username";
      this.EditUsername.LabelKey = "Username";
      this.EditUsername.Type = InputType.Text;
      this.EditUsername.IsRequired = true;

      this.EditEmail = new TextBoxOptions();
      this.EditEmail.Value = User.email;
      this.EditEmail.Name = "Email";
      this.EditEmail.LabelKey = "Email";
      this.EditEmail.Type = InputType.Text;
      this.EditEmail.IsRequired = true;

      this.EditSamAccount = new TextBoxOptions();
      this.EditSamAccount.Value = User.samAccount;
      this.EditSamAccount.Name = "SamAccount";
      this.EditSamAccount.LabelKey = "SamAccount";
      this.EditSamAccount.Type = InputType.Email;


      this.EditUserDepartment = new DropdownOptions();
      this.EditUserDepartment.Name = "DepartmentID"
      this.EditUserDepartment.LabelKey = "Department"
      this.EditUserDepartment.SelectedItems = this.departmentsList.filter((item) => { return parseInt(item.key) == User.departmentID; }).map((item) => item.key)[0];
      this.EditUserDepartment.DataSource = this.departmentsList
      this.EditUserDepartment.SingleSelection = true;
      this.EditUserDepartment.AllowSearchFilter = true;

      this.EditUserPermissions = new DropdownOptions();
      this.EditUserPermissions.Name = "PermissionSets"
      this.EditUserPermissions.LabelKey = "PermissionSets"
      this.EditUserPermissions.SelectedItems = this.permissionSetList.filter(function (tag) {
        return User.permSetList.indexOf(parseInt(tag.key)) >= 0;
      }).map((item) => item.key);
      this.EditUserPermissions.DataSource = this.permissionSetList
      this.EditUserPermissions.SingleSelection = false;
      this.EditUserPermissions.AllowSearchFilter = true;
      this.EditUserPermissions.IsRequired = true;

      this.modalService.open(EditUserModal);
      this.utilityService.stopBlockUI();
    });


  }

  editUser() {
    if (this.EditUserForm.invalid) {
      return;
    }
    else {
      let ResultModel = this.EditUserForm.value;
      let UserModel = new EditUserModel();
      UserModel.ID = this.UserId;
      UserModel.Username = ResultModel.Username;
      UserModel.Email = ResultModel.Email;
      UserModel.NameAR = ResultModel.Name.ArabicValue;
      UserModel.NameEN = ResultModel.Name.EnglishValue;
      UserModel.SamAccount = ResultModel.SamAccount;
      if (ResultModel.DepartmentID != undefined)
        UserModel.DepartmentID = Number(ResultModel.DepartmentID);
      let PermissionSets = ResultModel.PermissionSets as string[]
      UserModel.PermissionIDs = PermissionSets.map((i) => Number(i));
      let internationalNumber: string = null;
      if (ResultModel.MobileNumber != null) {
        internationalNumber = ResultModel.MobileNumber.internationalNumber as string;
        internationalNumber = internationalNumber.replace(/\s/g, "");
      }
      UserModel.Mobile = internationalNumber;
      this.userService.EditUser(UserModel).subscribe((result) => {
        this.modalService.dismissAll();
        let element = this.input as any;
        element.UpdatePaging();
        this.resetUsersCount();
        this.disableButtons();
      }, (error) => {

      })
    }
  }

  exportExcel() {
    let params = new HttpParams();
    params = params.append("permissionIds", this.UsersForm.controls["permissionsets"].value == undefined ? "" : this.UsersForm.controls["permissionsets"].value);
    params = params.append("accountStatusIDs", this.UsersForm.controls["accountstatus"].value == undefined ? "" : this.UsersForm.controls["accountstatus"].value);
    params = params.append("lockedStatusIds", this.UsersForm.controls["lockedstatus"].value == undefined ? "" : this.UsersForm.controls["lockedstatus"].value);
    params = params.append("departmentIds", this.UsersForm.controls["departments"].value == undefined ? "" : this.UsersForm.controls["departments"].value);
    params = params.append("nameFilter", this.UsersForm.controls["searchTextBox"].value == undefined ? "" : this.UsersForm.controls["searchTextBox"].value);
    this.userService.Export(params).subscribe((result) => {
      let FileDTO = result as any
      const file = new Blob([FileDTO], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs(file, `Users.xlsx`);

    }, (error) => {

    })

  }

  //One user functions
  showActivateUserModal(User: any, isActivateModel: boolean, ActivateUserModal) {
    this.utilityService.startBlockUI()
    this.ActivatUserList = []
    this.ActivatUserList.push(User);
    this.Name = this.language == "en" ? User.name.english : User.name.arabic;
    this.Email = User.email
    this.ShowActivateModelData = isActivateModel
    this.modalService.open(ActivateUserModal);
    this.utilityService.stopBlockUI();

  }

  showResetPasswordUserModal(User: any, ResetPasswordUserModal) {
    this.utilityService.startBlockUI()
    this.ResetPasswordUserList = []
    this.ResetPasswordUserList.push(User);
    this.Name = this.language == "en" ? User.name.english : User.name.arabic;
    this.Email = User.email
    this.modalService.open(ResetPasswordUserModal);
    this.utilityService.stopBlockUI();


  }

  showSendActivationEmailModal(User: any, SendActivationEmailModal) {
    this.utilityService.startBlockUI()
    this.SelectedUserList = []
    this.SelectedUserList.push(User);
    this.Name = this.language == "en" ? User.name.english : User.name.arabic;
    this.Email = User.email
    this.OpenSendActivationEmailModal = false;
    this.modalService.open(SendActivationEmailModal);
    this.utilityService.stopBlockUI();

  }

  deleteUserFromList(user: any) {
    this.UserPagingResult.find(u => u.id === user.id).selected = false;
    this.SelectedUserList = this.SelectedUserList.filter(item => item != user);
    if (user.isActive)
      this.activatedUsersSelected -= 1;
    else
      this.deActivatedUsersSelected -= 1;
    this.enableButtons();
    if (this.SelectedUserList.length <= 0) {
      this.modalService.dismissAll();

    }

  }

  showsetPasswordUserModal(User: any, setPasswordUserModal) {
    this.utilityService.startBlockUI();
    this.SetUserPasswordForm = new FormGroup({});
    this.setPasswordUserList = [];
    this.setPasswordUserList.push(User);
    this.Name = this.language == "en" ? User.name.english : User.name.arabic;
    this.Email = User.email;

    this.Password = new TextBoxOptions();
    this.Password.HideLabel = true;
    this.Password.Type = InputType.Password;
    this.Password.IsRequired = true;

    this.customValidation.functionBody = (control) => {
      let Password = this.SetUserPasswordForm.controls["Password"].value;
      if (control.value != Password)
        return { 'customerError': true };
      return null;
    };
    this.customValidation.massage = this.utilityService.getResourceValue("PasswordNotMatch");

    this.PasswordConfirmation = new TextBoxOptions();
    this.PasswordConfirmation.Name = "PasswordConfirmation";
    this.PasswordConfirmation.HideLabel = true;
    this.PasswordConfirmation.Type = InputType.Password;
    this.PasswordConfirmation.IsRequired = true;
    this.PasswordConfirmation.CustomValidation = [this.customValidation];

    this.modalService.open(setPasswordUserModal);
    this.utilityService.stopBlockUI();
  }


  activate() {
    this.userService.ActivateUsers(this.ActivatUserList).subscribe((result) => {
      this.modalService.dismissAll();
      let element = this.input as any;
      element.UpdatePaging();
      this.resetUsersCount();
      this.disableButtons();
    }, (error) => {

    })
  }

  deactivate() {
    this.userService.DeactivateUsers(this.ActivatUserList).subscribe((result) => {
      this.modalService.dismissAll();
      let element = this.input as any;
      element.UpdatePaging();
      this.resetUsersCount();
      this.disableButtons();
    }, (error) => {

    })
  }

  resetPassword() {

    this.userService.ResetUsersPassword(this.ResetPasswordUserList).subscribe((result) => {
      this.modalService.dismissAll();
      let element = this.input as any;
      element.UpdatePaging();
      this.resetUsersCount();
      this.disableButtons();
    }, (error) => {

    })

  }
  setPassword() {
    if (this.SetUserPasswordForm.invalid) {
      return;
    }
    else {
      let ResultModel = this.SetUserPasswordForm.value;
      for (let index = 0; index < this.setPasswordUserList.length; index++) {
        var element = this.setPasswordUserList[index];
        element.Password = ResultModel.Password
        element.ConfirmPassword = ResultModel.PasswordConfirmation
      }
      this.userService.SetUsersPassword(this.setPasswordUserList).subscribe((result) => {
        this.modalService.dismissAll();
        let element = this.input as any;
        element.UpdatePaging();
        this.resetUsersCount();
        this.disableButtons();
      }, (error) => {

      })
    }
  }

  sendActivationEmailForUser() {
    this.userService.SendActivationEmailForUser(this.SelectedUserList).subscribe((result) => {
      this.modalService.dismissAll();
      this.SelectedUserList = [];
      let element = this.input as any;
      element.UpdatePaging();
      this.resetUsersCount();
      this.disableButtons();
    }, (error) => {

    })

  }


  //Users List Functions 
  activateUserList() {
    this.userService.ActivateUsers(this.SelectedUserList).subscribe((result) => {
      this.modalService.dismissAll();
      this.SelectedUserList = [];
      let element = this.input as any;
      element.UpdatePaging();
      this.resetUsersCount();
      this.disableButtons();
    }, (error) => {

    });
  }
  deactivateUserList() {
    this.userService.DeactivateUsers(this.SelectedUserList).subscribe((result) => {
      this.modalService.dismissAll();
      this.SelectedUserList = [];
      let element = this.input as any;
      element.UpdatePaging();
      this.resetUsersCount();
      this.disableButtons();
    }, (error) => {

    });
  }
  resetUserPasswordList() {
    this.userService.ResetUsersPassword(this.SelectedUserList).subscribe((result) => {
      this.modalService.dismissAll();
      this.SelectedUserList = [];
      let element = this.input as any;
      element.UpdatePaging();
      this.resetUsersCount();
      this.disableButtons();
    }, (error) => {

    });
  }
  //Show activate,deactivate,resetPassword,sendactivationemail modals
  showConfirmationModal(type: number, ConfirmationModal) {
    this.IsOpenConfirmationModal = false;
    this.utilityService.startBlockUI();
    switch (type) {
      case 1:
        this.ConfirmationMessage = this.utilityService.getResourceValue("ActivateConfirmation");
        this.ConfirmationModalType = 1
        break;
      case 2:
        this.ConfirmationMessage = this.utilityService.getResourceValue("DeactivateConfirmation");
        this.ConfirmationModalType = 2
        break;
      case 3:
        this.ConfirmationMessage = this.utilityService.getResourceValue("ResetPasswordConfirmation");
        this.ConfirmationModalType = 3
        break;
      case 4:
        this.ConfirmationMessage = this.utilityService.getResourceValue("SendActivationMailConfirmation");
        this.ConfirmationModalType = 4
        break;

      default:
        break;
    }
    this.modalService.open(ConfirmationModal);
    this.utilityService.stopBlockUI();

  }

}
